export const removeObjectProperties = (values, object) => {
  const newObject = {...object};

  if (Array.isArray(values)) {
    values.forEach(val => delete newObject[val]);
  } else {
    delete newObject[values];
  }
  return newObject;
};
